import { PrimaryButton } from "components/Button/style";
import styled from "styled-components";

export const FiltrosContainer = styled.div`
  margin-bottom: 1rem;
  padding: 20px;
  background-color: ${({ theme }) => theme.colors.neutral.neutral05};
  border-radius: 8px;
`;

export const BotoesFiltro = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 8px;
  padding-top: 1.8rem;
`;

export const Button = styled(PrimaryButton)`
  font-size: 12px !important;
  padding: 0.5rem 1rem;
  height: 2.2rem;
`;

export const TabelaHeader = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin: 1.75rem 0 0.5rem;
`;

export const WrapperPesquisa = styled.div`
  position: relative;
  display: inline-flex;
  align-items: center;

  svg {
    position: absolute;
    left: 12px;
    color: ${({ theme }) => theme.colors.neutral.neutral40};
    font-size: 0.85rem;
    pointer-events: none;
  }
`;

export const InputPesquisa = styled.input`
  border: 1px solid #dee2e6;
  border-radius: 4px;
  padding: 8px 12px 8px 32px;
  height: 38px;
  font-size: 0.85rem;
  width: 220px;
  &:focus {
    outline: none;
  }
`;

export const IconeTooltipServico = styled.span`
  cursor: help;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.colors.project.main};
  color: #fff;
  font-size: 0.55rem;
  margin-left: 4px;
`;
